import { Container } from "@/components";
import { CONSTANTS } from "@/constants";
import { IMenuItem } from "@/interfaces";
import { ESize } from "@/interfaces/enums";
import Link from "next/link";
import { Fragment } from "react";

export const PrivateFooter = () => {

  const NAV_ITEMS: IMenuItem[] = [CONSTANTS.URLS.PRIVACY, CONSTANTS.URLS.TERMS];

  return(
    <footer className="bg-white">
      <Container additionalClassNames="flex items-center md:flex-row md:items-end py-4" size={ESize.LG}>
        <p className="mb-4 md:mb-0">&copy;{new Date().getFullYear()}, {CONSTANTS.PROJECT_TITLE}. All rights reserved</p>

        <nav aria-label="Terms and privacy navigation" className="md:ml-auto">
          <ul className="flex items-center list-style-none">
            {NAV_ITEMS.map(({ id, label, href }, index) => (
              <Fragment key={id}>
                <li className="ml-0">
                  <Link className="color-black text-decoration-none" href={String(href)} target="_blank">{label}</Link>
                </li>
                {index < NAV_ITEMS.length - 1 && (
                  <span aria-hidden="true" className="block mx-2">|</span>
                )}
              </Fragment>
            ))}
          </ul>
        </nav>
       
      </Container>

    </footer>
  )
};